import {
    Download, Loader2
} from 'lucide-react';
import { useExportRequests } from '../../Hooks/useExportRequests';

export default function RequestsHeader() {
    const { mutate: exportRequests, isPending: isExporting } = useExportRequests();

    const handleExport = () => {
        exportRequests();
    };

    return (
        <div className="flex items-center justify-between mb-3">
            <h1 className="text-xl font-bold text-gray-900">Requests</h1>

            <div className="flex items-center gap-2">
                <button
                    onClick={handleExport}
                    disabled={isExporting}
                    className="px-3 py-2 border border-gray-300 rounded-lg text-xs font-medium flex items-center gap-1.5 bg-white shadow-sm hover:bg-gray-50 disabled:opacity-70 transition"
                >
                    {isExporting ? (
                        <>
                            <Loader2 className="w-4 h-4 animate-spin text-gray-600" />
                            Exporting...
                        </>
                    ) : (
                        <>
                            <Download className="w-4 h-4 text-gray-600" />
                            Export to CSV
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}